import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { StyledButton } from '../../../../Components/Generics.styled';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const SelectAdvertiserContainer = styled.div`
    min-height: 300px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
    margin-bottom: 50px;
`;

const StyledNavButtons = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const AddAdvertiserApplet = styled.div``;

const SelectAdvertiser = (props) => {
    const {
        campaignData,
        handleNavButtonNext,
        advertisers,
        setAdvertisers,
        setCurrentAdvertiser,
        currentAdvertiser,
    } = props;
    const history = useHistory();

    const { advertiserList } = { ...advertisers };
    const handleBackButton = () => {
        history.push('/portal/campaign/createACampaign');
    };

    const handleAdvertiserChange = (e, value) => {
        setCurrentAdvertiser(value);
    };

    return (
        <SelectAdvertiserContainer>
            <Title>Select Advertiser</Title>
            <AddAdvertiserApplet>
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={advertiserList || []}
                    value={currentAdvertiser}
                    getOptionLabel={(option) => `${option.companyName}`}
                    onChange={(e, value) => handleAdvertiserChange(e, value)}
                    sx={{ width: 300 }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Advertiser"
                            label="Select Advertiser"
                        />
                    )}
                />
            </AddAdvertiserApplet>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleBackButton()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={campaignData.advertiserId === '' || currentAdvertiser === null}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </SelectAdvertiserContainer>
    );
};

SelectAdvertiser.propTypes = {
    campaignData: propTypes.shape({ advertiserId: propTypes.number }),
    handleNavButtonNext: propTypes.func,
    advertisers: propTypes.shape({
        advertiserList: propTypes.array,
    }),
    setAdvertisers: propTypes.func,
    currentAdvertiser: propTypes.shape({}),
    setCurrentAdvertiser: propTypes.func,
    setCampaignData: propTypes.func,
};

SelectAdvertiser.defaultProps = {
    campaignData: { categoryId: '', category: '' },
    setCampaignData: () => {},
    handleNavButtonNext: () => {},
    setAdvertisers: () => {},
};
export default SelectAdvertiser;
